/**
 * Locomotion (RL walking) setup, mirrored from the server.
 *
 * The server owns the home pose, the forward direction and the foot
 * list; every edit goes over the websocket and comes back as one
 * `locomotion_state` message, which this slice stores verbatim. The only
 * client-side state is `locomotionLoading`, which goes up when a request
 * is sent and down when the reply lands, so the panel can hold its
 * buttons still in between.
 */

import type { LocomotionSlice, LocomotionState, ViewerSliceCreator } from "./types";

export const locomotionInitialState: LocomotionState = {
  locomotionHomePose: {},
  locomotionForwardWorld: [1, 0, 0],
  locomotionFeet: [],
  locomotionDetectedFeet: [],
  locomotionLinkReach: [],
  locomotionBaseInstanceId: null,
  locomotionBaseLink: null,
  locomotionBaseHeight: null,
  locomotionError: null,
  locomotionLoading: false,
};

export const createLocomotionSlice: ViewerSliceCreator<LocomotionSlice> = (set) => ({
  ...locomotionInitialState,

  setLocomotionState: (msg) =>
    set((state) => {
      // The server drops None fields from the wire, so an error state arrives
      // without base_height / base_link at all: read them as null, not undefined.
      state.locomotionHomePose = msg.home_pose ?? {};
      state.locomotionForwardWorld = msg.forward_world ?? [1, 0, 0];
      state.locomotionFeet = msg.feet ?? [];
      state.locomotionDetectedFeet = msg.detected_feet ?? [];
      state.locomotionLinkReach = msg.link_reach ?? [];
      state.locomotionBaseInstanceId = msg.base_instance_id ?? null;
      state.locomotionBaseLink = msg.base_link ?? null;
      state.locomotionBaseHeight = msg.base_height ?? null;
      state.locomotionError = msg.error ?? null;
      state.locomotionLoading = false;
    }),

  setLocomotionLoading: (loading) =>
    set((state) => {
      state.locomotionLoading = loading;
    }),
});
